import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.command.funktionsbereich-hinzufuegen-multi';
import * as api from '../../../clients/veranstaltungen';

@Injectable()
export class VeranstaltungenFunktionsbereichHinzufuegenMultiEffects {

    FunktionsbereichHinzufuegenMulti$ = createEffect(() => this.actions$.pipe(
        ofType(ac.POST_FUNKTIONSBEREICH_HINZUFUEGEN_MULTI),
        mergeMap((x: ac.PostFunktionsbereichHinzufuegenMultiAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().postFunktionsbereichHinzufuegenMulti(x.funktionsbereichHinzufuegenMultiRequest).pipe(
                map((result: any) => {
                    return new ac.PostFunktionsbereichHinzufuegenMultiErfolgreichAction(result, x.funktionsbereichHinzufuegenMultiRequest, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.PostFunktionsbereichHinzufuegenMultiFehlerAction(error, x.funktionsbereichHinzufuegenMultiRequest, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.FunktionsbereicheCommandService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.FunktionsbereicheCommandService {
        if (this.service === null) {
            this.service = this.injector.get(api.FunktionsbereicheCommandService);
        }
        return this.service;
    }
}
